import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      // Show error toast if available
      if (typeof window.showToast === 'function') {
        window.showToast('Logout failed. Please try again.', 'error');
      }
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <nav className="nav nav--tours">
        <Link to="/" className="nav__el" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }} onClick={closeMobileMenu}>
          <img src="/img/AeLogo.ico" alt="Aethermap Logo" style={{ width: 32, height: 32, verticalAlign: 'middle', borderRadius: '15%' }} />
          <span style={{ fontWeight: 700, fontSize: '1.2rem' }}>Aethermap</span>
        </Link>
      </nav>
      
      {/* Mobile menu button */}
      <button 
        className="mobile-menu-button" 
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}></span>
      </button>
      
      <nav className={`nav nav--user ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        {isAuthenticated ? (
          <>
            <Link to="/" className="nav__el" onClick={closeMobileMenu}>
              Overview
            </Link>
            <Link to="/characters" className="nav__el" onClick={closeMobileMenu}>
              Characters
            </Link>
            <Link to="/elements" className="nav__el" onClick={closeMobileMenu}>
              Elements
            </Link>
            <Link to="/pillars" className="nav__el" onClick={closeMobileMenu}>
              Pillars
            </Link>
            <Link to="/playmat" className="nav__el" onClick={closeMobileMenu}>
              Playmat
            </Link>
            {user?.role === 'admin' && (
              <Link to="/kanban" className="nav__el" onClick={closeMobileMenu}>
                Kanban
              </Link>
            )}
            <div className="nav__el">
              <span className="nav__user-name">Hello, {user?.name}</span>
            </div>
            <button onClick={handleLogout} className="nav__el nav__el--logout">
              Logout
            </button>
          </>
        ) : (
          <Link to="/login" className="nav__el nav__el--login" onClick={closeMobileMenu}>
            Log in
          </Link>
        )}
      </nav>
    </header>
  );
};

export default Header; 